// OrderListReport.js
// Component for the Order List Report

// Imports
import React from 'react';
import ReportCard from './ReportCard';
import OrderSelect from './OrderSelect';
import dateFormat from 'dateformat';
import PropTypes from 'prop-types';
import DateInput from './DateInput';

// Component Class
// Shows Order List Report Card
class OrderListReport extends React.Component {
  // Constructor
  constructor(props) {
    super(props);
    this.state = {
      order: null,
      delivery: dateFormat(new Date(), "dd/mm/yyyy"),
    }
  }
  
  // Returns the filename for the downloaded report
  getFilename = () => {
    var order = this.state.order;
    var date = order && order.dateClosed ? new Date(order.dateClosed) : new Date();
    var dateStr = dateFormat(date, "yyyy.mm.dd");
    return "Carlinhos_Pedidos_"+dateStr+".pdf"
  }

  // Returns the processed report object
  getReport = () => {
    return this.props.report.getMultiClientReport(this.state.order, this.state.delivery);
  }

  // Sets the current order to generate reports for
  setOrder = (order) => {
    this.setState({order: order});
  }

  // Sets the target delivery date
  setDelivery = (date) => {
    this.setState({delivery: date !== "" ? date : null})
  }

  // Renders Component
  render() {
    return (
      <ReportCard
        title="Resumo de Pedidos"
        description="Resumo de todos os pedidos de todos os clientes em uma data."
        getReport={this.getReport}
        getFilename={this.getFilename}
      >
        <center>
          <OrderSelect
            orders={this.props.orders}
            selected={this.state.order}
            setOrder={this.setOrder}
          />
          <br />
          <br />
          <DateInput
            setDate={this.setDelivery}
            date={this.state.delivery}
          />
        </center>
        <br />
      </ReportCard>
    );
  }
}

// Required Properties
OrderListReport.propTypes = {
  report: PropTypes.object.isRequired,
  orders: PropTypes.object.isRequired,
}

// Exports
export default OrderListReport;


// WEBPACK FOOTER //
// ./src/components/ReportView/OrderListReport.js